<template>
  <!--  <iframe style="width: 100%" :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + this.url"/>-->
<!--  <FrameIframe v-if="parentData.file_id" :file-id="parentData.file_id" class="frame"></FrameIframe>-->
  <FileViewer v-if="parentData.file_id" :file-type="fileType" :url="url" class="frame" ></FileViewer>
</template>

<script>

import FileViewer from "@/views/applications/oa/FileViewer.vue";

export default {
  name: "CrmPdfView",
  components: {FileViewer},

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      fileType: '',
      url: '',
      currentVersion: '',
    }
  },

  async created() {
    let suffix = this.parentData['file@file_id'][0]?.file_suffix.toLowerCase();
    this.fileType = this.calcFileType(suffix);
    this.url = this.parentData['file@file_id'][0]?.url;
  },

  methods: {
    calcFileType(suffix) {
      switch (suffix) {
        case '.pdf':
          return 'pdf';
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.bmp':
          return 'img';
        case '.doc':
        case '.docx':
          return 'word';
        case '.xls':
        case '.xlsx':
          return 'excel';
        case '.ppt':
        case '.pptx':
          return 'ppt';
        case '.mp4':
          return 'mp4';
      }

      return 'others'
    },
  }
}
</script>

<style scoped>

.frame {
  height: calc(100% - 8px);
  width: 100%;
}

</style>